import { dispatchGsiCredential } from './gsiCredentialBridge';

const GSI_SRC = 'https://accounts.google.com/gsi/client';
const GSI_ATTR = 'data-kakau-gsi';

let gsiLoadPromise = null;
let didInitializeGsi = false;

/**
 * Loads the Google Identity Services client script once.
 */
export function loadGoogleIdentityScript() {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.google?.accounts?.id) {
    return Promise.resolve();
  }

  if (gsiLoadPromise) {
    return gsiLoadPromise;
  }

  gsiLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[${GSI_ATTR}]`);
    if (existing) {
      if (window.google?.accounts?.id) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => {
        gsiLoadPromise = null;
        reject(new Error('gsi_script_error'));
      }, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = GSI_SRC;
    script.async = true;
    script.defer = true;
    script.setAttribute(GSI_ATTR, '1');
    script.onload = () => resolve();
    script.onerror = () => {
      gsiLoadPromise = null;
      reject(new Error('gsi_script_error'));
    };
    document.head.appendChild(script);
  });

  return gsiLoadPromise;
}

/**
 * Initializes GSI once. The hosted-domain hint prefers @kakau.co accounts.
 * The server still rejects any other domain.
 */
export function ensureGsiInitialized(clientId) {
  const id = window.google?.accounts?.id;
  if (!id || didInitializeGsi) {
    return;
  }
  id.initialize({
    client_id: clientId,
    hd: 'kakau.co',
    callback: (response) => {
      if (response.credential) {
        dispatchGsiCredential(response.credential);
      }
    },
  });
  didInitializeGsi = true;
}
